export interface Point {
  x: number
  y: number
}

export interface EdgeRenderCoordinates {
  x1: number
  y1: number
  x2: number
  y2: number
}

/**
 * Calculates SVG line coordinates for an edge between two points.
 */
export const calculateEdgeCoordinates = (
  from: Point,
  to: Point,
): EdgeRenderCoordinates => {
  return {
    x1: from.x,
    y1: from.y,
    x2: to.x,
    y2: to.y,
  }
}

/**
 * Helper to get the center screen position of a DOM element matching a target ID.
 */
export const queryTargetCenter = (
  targetId: string,
  root: ParentNode = document,
): Point | null => {
  if (typeof document === 'undefined') return null

  // Query elements having data-* id attributes matching targetId
  const selectors = [
    `[data-orbit-target][data-checklist-id="${targetId}"]`,
    `[data-orbit-target][data-node-id="${targetId}"]`,
    `[data-orbit-target][data-goal-id="${targetId}"]`,
    `[data-orbit-target][data-task-id="${targetId}"]`,
    `[data-orbit-target][data-marker-id="${targetId}"]`,
    `[data-orbit-target][data-shape-id="${targetId}"]`,
    `[data-orbit-target][data-field-id="${targetId}"]`,
    `[data-orbit-target][data-attendee-id="${targetId}"]`,
    `[data-orbit-target][data-meeting-id="${targetId}"]`,
    `[data-checklist-id="${targetId}"]`,
    `[data-node-id="${targetId}"]`,
    `[data-shape-id="${targetId}"]`,
    `[id="${targetId}"]`,
  ]

  for (const selector of selectors) {
    const el = root.querySelector<HTMLElement>(selector)
    if (el) {
      const rect = el.getBoundingClientRect()
      return {
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2,
      }
    }
  }

  return null
}
